export const Colors = {
  primary: "#836BFF",
  secondary: "#1E0E62",
  grey: "#EBEAED",
  white: "#fff",
  black: "#000",
};
